export default __webpack_public_path__ + "30cac8cf2ac0869f86fc8d2d3aaa7744.glb";